import { createAction, props } from '@ngrx/store';
import { InvoiceStatusWidgetView } from '@feature/invoice-status/invoice-status-widget-types';
import { ITable } from '@common/models/table';
import { Currency } from '@currency/models/currency.model';

const source = '[Invoice Status Widget]';
const name = (actionName: string) => `${source } ${actionName}`;

export const setView = createAction(
  name('Set View'),
  props<{ widgetId: number, view: InvoiceStatusWidgetView }>()
);


export const setCurrency = createAction(
  name('Set Currency'),
  props<{ widgetId: number, currency: Currency  }>()
);


export const enterDrillDown = createAction(
  name('Enter Drill Down'),
  props<{ widgetId: number, invoiceStatus: string }>()
);

export const exitDrillDown = createAction(
  name('Exit Drill Down'),
  props<{ widgetId: number }>()
);


export const apiLoad = createAction(
  name('API Load'),
  props<{ widgetId: number, external: boolean, supplierRef?: number, creditorUri?: number }>()
);

export const apiLoadComplete = createAction(
  name('API Load Complete'),
  props<{ widgetId: number, data: ITable }>()
);





